import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '30px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        FAQ
                                    </h2>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Whats the company mission?
                                    </h3>
                                    <p>
                                        Audiencerate is a technology company that helps data providers, agencies and/or advertisers to monetize data or target
                                        new prospects. Through predictive models Audiencerate has a deep capability to understand users' online & offline
                                        journeys. Audiencerate's platform is very simple and easy to use. Data providers can onboard audience data and
                                        individual and combined data segments, making them accessible for use in media campaigns in the programmatic ecosystem.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        How Audience Size are calculated?
                                    </h3>
                                    <p>
                                        All the audience sizes are updated daily and are calculated from <b>today to 30 days before.</b>
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Can a single audienceId be mapped to multiple DMPs/DMP products?
                                    </h3>
                                    <p>
                                        Sure! You can use the same audience id for creating multiple licenses using different DMP + Products and SEAT ID
                                        combinations using the same audience. the keys are AudienceID, DMP, DMP Product and seat ID.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Revenue reporting
                                    </h3>
                                    <p>
                                        The revenues are updated every <b>8 hours</b> 3 times a day and are grouped by active licenses. See{' '}
                                        <a href="/doc/revenue">Revenue Documentation</a> for more details.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Licensing: Best Pratices
                                    </h3>
                                    <p>
                                        <ul>
                                            <li>
                                                <u>TTL</u> - we suggest that you initially set your segment’s TTL to 30 days. This will maximize the available
                                                audience that Google sees while not creating staleness in your cookie set which might impact performance.
                                            </li>
                                            <li>
                                                <u>Naming</u> - your segment names should be descriptive in nature. “Auto intenders”, “home cooks” and “IT
                                                decision makers” are three examples. Avoid using your own internal company naming conventions and do not put
                                                segment size numbers in the description nor use numbers to name the segment.
                                            </li>
                                        </ul>
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        In which countries Audiencerate can sell?
                                    </h3>
                                    <p>Audiencerate can sell worldwide, there is no limit in which country you can select.</p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Can I create a custom application using your services?
                                    </h3>
                                    <p>
                                        Sure! Audiencerate has an <a href="https://apidocs.audiencerate.com/">API</a> that empower users to create custom
                                        application! All the action you see on the Audiencerate dashboard are callable as Rest API.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Where Audiencerate can sell my segments?
                                    </h3>
                                    <p>Audiencerate has direct access to all Google’s universe: so we can sell to all Google products!</p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Anonymization and Privacy
                                    </h3>
                                    <p>
                                        We store no PII within the Audiencerate system itself, and automatically delete all input files within 30 days.
                                        <br />
                                        We have a strict policy regarding Privacy, to comply with GDPR. see{' '}
                                        <a href="http://www.audiencerate.com/privacy/">Privacy policy</a> for more details.
                                        <br />
                                        We are members of <a href="https://www.networkadvertising.org/participating-networks/">NAI</a>, so we'are compliant with
                                        the best in the industry.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        What is the S3 bucket access key and secret key?
                                    </h3>
                                    <p>
                                        You need to create a IAM user and register in the Audiencerate Dashboard in the{' '}
                                        <a href="https://app.audiencerate.com/servertoserver">S2S section</a> to generate a policy to enable your IAM user to
                                        access our S3. Please follow our guide here: <a href="https://app.audiencerate.com/doc/file_upload">File upload</a>.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        What are the api credentials?
                                    </h3>
                                    <p>
                                        Please see the example of basic file upload example:{' '}
                                        <a href="https://app.audiencerate.com/servertoserver">S2S section</a>. Click “Code Snippet” tab and see the example
                                        under “SDK Upload Code Snippet”, you can see how to call the apis. (some of the values needed are pre-filled for your
                                        account)
                                        <br />
                                        <br />
                                        Here <u>IAM_ACCESS_KEY and IAM_SECRET_KEY</u> are your was IAM credentials that you allowed in the S2S section of the
                                        dashboard.
                                        <u>Email and password</u> are your dashboard credentials used to generate API Sessions.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Licensing: Is percentage rate supported or only cpm?
                                    </h3>
                                    <p>For now we got cpm pricing only.</p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        File upload: What happens if we include the same file in multiple calls? i.e. if we have a failure on our end and we
                                        need to reprocess something?
                                    </h3>
                                    <p>
                                        Audiencerate process the files uploaded only after:
                                        <ul>
                                            <li>
                                                For <b>Basic Upload</b> we process the files only after you call{' '}
                                                <a href="https://apidocs.audiencerate.com/#/default/post_upload_notification">Basic Upload Notification API</a>
                                            </li>
                                            <li>
                                                For <b>Bulk Upload</b> we process the files only after you call{' '}
                                                <a href="https://apidocs.audiencerate.com/#/default/post_audience_bulk_upload">Bulk Upload Notification API</a>
                                            </li>
                                        </ul>
                                        See <a href="https://app.audiencerate.com/doc/file_upload">File upload Documentation</a> for more info.
                                    </p>
                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        File upload: Is there an endpoint to check the status of the uploads?
                                    </h3>
                                    <p>
                                        Call <a href="https://apidocs.audiencerate.com/#/default/get_eventUploadDetails">Upload Status API</a> to check the
                                        status of your uploads.
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
